import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoSpaces]'
})
export class NoSpacesDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Remove spaces and keep only numeric characters
                                            // for space     // for string.
    const trimmedValue = input.value.replace(/\s+/g, '').replace(/\D/g, '');  
    this.ngControl.control?.setValue(trimmedValue);
  }
  
}